// extracted by mini-css-extract-plugin
export var aboveInput = "_my-0";
export var actionButton = "_my-5";
export var actionButtonContainer = "_my-1";
export var actionIcon = "_my-6";
export var aiInfoContainer = "_my-2";
export var attachmentWrapper = "_my-7";
export var bold = "_my-3";
export var checkIcon = "_my-8";
export var clickingRecipientBar = "_my-11";
export var commentThreadSwitch = "_my-a";
export var draftImage = "_my-b";
export var draftImageContainer = "_my-c";
export var draftImages = "_my-e";
export var editButton = "_my-g";
export var editor = "_my-f";
export var editorContainer = "_my-y";
export var editorErrorTooltipWrapper = "_my-9";
export var headerDivider = "_my-h";
export var icon = "_my-i";
export var info = "_my-j";
export var internal = "_my-n";
export var internalDivider = "_my-k";
export var internalMessage = "_my-l";
export var messageInputCard = "_my-m";
export var messageInputForm = "_my-o";
export var messageInputFormInternal = "_my-p";
export var options = "_my-q";
export var publicMessageCustomer = "_my-s";
export var publicMessageMerchant = "_my-r";
export var removeImageButton = "_my-d";
export var replyButtons = "_my-t";
export var showSignatureButton = "_my-u";
export var spinner = "_my-v";
export var verticalButtonDivider = "_my-4";
export var visibilitySelector = "_my-w";
export var warning = "_my-x";
export var wrappingText = "_my-z";
export var writingInternalNoteTopBorder = "_my-10";